export const brandColors: string[] = [
  "#646969",
  "#52A748",
  "#EBA833",
  "#64C7CC",
  "#000000",
  "#E86A30",
  "#D75878",
  "#5839CB",
];
